import { render } from "./Previsionale.vue?vue&type=template&id=bf342d3a"
import script from "./Previsionale.vue?vue&type=script&lang=js"
export * from "./Previsionale.vue?vue&type=script&lang=js"

import "./Previsionale.vue?vue&type=style&index=0&id=bf342d3a&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__